import React from 'react';
import {
  AlertTriangle,
  Sparkles
} from 'lucide-react';

import { cn } from '@/lib/utils';

import type { IItemCheckerReport } from '../../api/ItemChecker.interface';

import { FormDialog } from './FormDialog';

type Props = {
  setAllData: React.Dispatch<React.SetStateAction<IItemCheckerReport[] | null>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
};

function ReportHeader({ setAllData, setLoading }: Props) {
  return (
    <div className="relative">
      <div className="flex w-full flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          {/* Enhanced Icon Container */}
          <div className={cn(
            "relative p-4 rounded-2xl",
            "bg-gradient-to-br from-red-600 via-orange-600 to-amber-600",
            "shadow-2xl shadow-red-500/20 dark:shadow-red-500/10",
            "group"
          )}>
            <AlertTriangle className="h-8 w-8 text-white" />
            <div className="absolute -top-1 -right-1">
              <Sparkles className="h-4 w-4 text-yellow-400 animate-pulse" />
            </div>
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
          </div>
          
          {/* Title and Description */}
          <div className="space-y-1">
            <h1 className="text-2xl font-bold bg-gradient-to-r from-red-700 to-orange-700 dark:from-red-400 dark:to-orange-400 bg-clip-text text-transparent">
              تقرير نواقص الأصناف
            </h1>
            <p className="text-sm text-muted-foreground max-w-lg">
              تحليل شامل للأصناف التي تحتاج إلى توفير مع عرض أفضل الخصومات المتاحة في السوق
            </p>
          </div>
        </div>
        
        {/* Action Button */}
        <FormDialog setAllData={setAllData} setLoading={setLoading} />
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute -bottom-4 left-0 right-0 h-px bg-gradient-to-r from-transparent via-red-500/20 to-transparent" />
    </div>
  );
}

export default ReportHeader;
